import { render, staticRenderFns } from "./ReportCjxf.vue?vue&type=template&id=004e1384&scoped=true&"
import script from "./ReportCjxf.vue?vue&type=script&lang=js&"
export * from "./ReportCjxf.vue?vue&type=script&lang=js&"
import style0 from "./ReportCjxf.vue?vue&type=style&index=0&id=004e1384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e1384",
  null
  
)

export default component.exports